var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoamRoller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1517 19.1516C11.6161 17.6872 11.6161 15.3128 10.1517 13.8483C8.68718 12.3839 6.31282 12.3839 4.84835 13.8483M10.1517 19.1516C8.68718 20.6161 6.31282 20.6161 4.84835 19.1516C3.38388 17.6872 3.38388 15.3128 4.84835 13.8483M10.1517 19.1516L19.1517 10.1517C20.6161 8.68718 20.6161 6.31282 19.1517 4.84835C17.6872 3.38388 15.3128 3.38388 13.8483 4.84835L4.84835 13.8483",
    stroke: "#191C1E",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoamRoller);
export default __webpack_public_path__ + "static/media/foamRoller.6773e4606858d367b12e5ccea98adbdf.svg";
export { ForwardRef as ReactComponent };